module.exports = __webpack_public_path__ + "img/logo.ea7740b5.png";